export default __webpack_public_path__ + "src/images/system_preface/8-0c7fbb.png";